"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.timeRangeSelectorShiftTypes = exports.timeAndPrecisionTypes = exports.timeAndPrecisionConfigurationKeys = void 0;
var timeAndPrecisionTypes = {
  fixed: 'fixed',
  fixedDay: 'fixedDay',
  last: 'last',
  next: 'next',
  predefined: 'predefined',
  usePrevious: 'usePrevious'
};
exports.timeAndPrecisionTypes = timeAndPrecisionTypes;
var timeAndPrecisionConfigurationKeys = {
  timeAndPrecisionType: 'timeAndPrecisionType',
  predefinedDateRange: 'predefinedDateRange',
  rangeValue: 'rangeValue',
  rangeType: 'rangeType',
  startDateTime: 'startDateTime',
  endDateTime: 'endDateTime',
  precisionType: 'precisionType',
  selectedPreviousRange: 'selectedPreviousRange'
};
exports.timeAndPrecisionConfigurationKeys = timeAndPrecisionConfigurationKeys;
var timeRangeSelectorShiftTypes = {
  minute: 'minute',
  hour: 'hour',
  day: 'day',
  week: 'week',
  month: 'month',
  quarter: 'quarter',
  year: 'year'
};
exports.timeRangeSelectorShiftTypes = timeRangeSelectorShiftTypes;